import { render, staticRenderFns } from "./KufangGoods.vue?vue&type=template&id=a463887a&scoped=true"
import script from "./KufangGoods.vue?vue&type=script&lang=js"
export * from "./KufangGoods.vue?vue&type=script&lang=js"
import style0 from "./KufangGoods.vue?vue&type=style&index=0&id=a463887a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a463887a",
  null
  
)

export default component.exports